import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_LIST_ORDERED: GlameraIconDefinition = {
  name: 'list-ordered',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-list-ordered-row glm-list-ordered-row-1" d="M11 5h10"></path>
    <path class="glm-list-ordered-row glm-list-ordered-row-2" d="M11 12h10"></path>
    <path class="glm-list-ordered-row glm-list-ordered-row-3" d="M11 19h10"></path>
    <g class="glm-list-ordered-number glm-list-ordered-number-1">
      <path d="M4 4h1v5"></path>
      <path d="M4 9h2"></path>
    </g>
    <path
      class="glm-list-ordered-number glm-list-ordered-number-2"
      d="M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02">
    </path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-list-ordered-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './list-ordered.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ListOrderedIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_LIST_ORDERED;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
